/**
 * Offline Banner
 *
 * Displays a non-intrusive banner when the API is unavailable.
 * Provides clear user feedback without blocking functionality.
 */

import { useApiStatus } from '../contexts/ApiStatusContext';

export function OfflineBanner(): JSX.Element | null {
  const { isApiAvailable, isLoading } = useApiStatus();

  // Don't show during initial load
  if (isLoading) {
    return null;
  }

  // Don't show if API is available
  if (isApiAvailable) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-amber-50 border border-amber-200 rounded-lg p-4 shadow-lg z-50"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-amber-600"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-medium text-amber-800">
            Eingeschränkte Verbindung
          </h3>
          <p className="mt-1 text-sm text-amber-700">
            Der Server ist momentan nicht erreichbar. Einige Funktionen sind möglicherweise nicht verfügbar.
          </p>
        </div>
      </div>
    </div>
  );
}
